import { parse } from 'date-fns';

export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';

export const dateStringToDateObject = (date: string, format: string = DEFAULT_DATE_FORMAT) => {
    return parse(date, format, new Date());
};
